import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { useIsBuzzEnabled } from '@/features/buzz/api'
import { ChartBlock, Period } from '@/ui-kit'
import { useLingui } from '@lingui/react/macro'
import { useState } from 'react'
import { useUserCallPoints, useUserReferralPoints } from '../api/points'
import { useFetchUserJobPoints } from '../api/useFetchUserJobPoints'
import { useFetchUserUptimePoints } from '../api/useFetchUserUptimePoints'

export function PointsChartBlock(): React.JSX.Element {
  const { t } = useLingui()
  const [pointsPeriod, setPointsPeriod] = useState<Period>('day')
  const { data: user } = useFetchUser(true)
  const { data: uptimePoints } = useFetchUserUptimePoints(pointsPeriod)
  const { data: points } = useFetchUserJobPoints(pointsPeriod)
  const { data: referralPoints } = useUserReferralPoints(pointsPeriod)
  const isBuzzEnabled = useIsBuzzEnabled()
  const { data: callPoints } = useUserCallPoints(pointsPeriod, { enabled: isBuzzEnabled })
  const targetDate = user ? { title: t`Account was created`, date: user.createdAt } : undefined

  return (
    <ChartBlock
      title={{ plural: t`DataHive Points`, singular: t`DataHive Point` }}
      data={points}
      data3={uptimePoints}
      data4={referralPoints}
      data5={callPoints}
      period={pointsPeriod}
      onPeriodChange={setPointsPeriod}
      targetDate={targetDate}
      isStackedBars
    />
  )
}
